import {ReactComponent as IcnUsd} from "../../assets/images/currencies/icn-usd.svg"

export const DummyOptions = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
  { value: 'test', label: 'Somesuperlongvaluebecausethathappens' },
  { value: 'moretest', label: 'Some super long value because that happens' },
]

export const DummyCurrencyOptions = [
  { value: 'usd', label: 'USD', icon: <IcnUsd/>},
]
